import { ThumbsUp, AlertTriangle } from 'lucide-react';
import { useWatch } from 'react-hook-form';
import { JobDescriptionCharactersLimit, type JobAdFormValues } from '../JobAdStep.schema';
import UIStrings from '@/Utils/UIStrings';

interface JobDescriptionCharCounterProps {
    hasError: boolean;
    error?: string;
}

function JobDescriptionCharCounter({ hasError, error }: JobDescriptionCharCounterProps) {
    const length = useWatch<JobAdFormValues>({ name: 'descriptionLen' }) as number;

    return (
        <div
            className={`flex h-11 items-center justify-between rounded-md border px-2.5 py-1.5 ${
                hasError
                    ? 'border-destructive text-destructive bg-red-50'
                    : 'border-indigo-800 bg-indigo-100 text-indigo-800'
            }`}
        >
            <span>{UIStrings.CharactersCounterWithLimit(length, JobDescriptionCharactersLimit)}</span>
            <div className="flex items-center gap-3">
                {hasError ? <AlertTriangle className="size-4" /> : <ThumbsUp className="size-4" />}
                {hasError && <span>{error}</span>}
                <span>{UIStrings.RecommendedCharacters}</span>
            </div>
        </div>
    );
}

export default JobDescriptionCharCounter;
